import { createFileRoute } from '@tanstack/react-router'
import { AcceptInvitePage } from '@/features/workspace/AcceptInvitePage'

/**
 * Public accept-invite route — Story E02.09.
 *
 * Lives at `/accept-invite/$token` (top-level, NOT inside `_authenticated`)
 * because the token itself is the credential the backend validates. If the
 * user is not signed in, the backend returns 401 and the page redirects to
 * `/login?returnTo=/accept-invite/<token>` so the flow resumes after login.
 *
 * No `beforeLoad` redirect: auth-gating happens in `useAcceptInviteMutation`
 * `onError` per AC-06 (we need to attempt the call first to learn whether
 * the cookie is present, and to keep the auth-failure path observable in
 * the network tab during manual verification).
 */
export const Route = createFileRoute('/accept-invite/$token')({
  component: AcceptInviteRouteComponent,
})

function AcceptInviteRouteComponent() {
  const { token } = Route.useParams()
  return <AcceptInvitePage token={token} />
}
